import { render } from "./Microsoft365About.vue?vue&type=template&id=05c94512"
import script from "./Microsoft365About.vue?vue&type=script&lang=js"
export * from "./Microsoft365About.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__